import LayerMenuPanel from './LayerMenuPanel';

export default class MenuItem {
  get CLASSNAMES() {
    return {
      active: 'active',
      activeLayersContainer: 'active-layers',
      divider: 'header-divider',
    };
  }
  constructor(itemEl, layersContainerEl) {
    this.item = itemEl;
    this.panel = null;
    this.layersContainer = layersContainerEl;
    this.header = document.querySelector('header');
    this.whenActiveHandler = () => {};
    this.whenInactiveHandler = () => {};
    if (this.item) {
      this.init();
    }
  }
  init() {
    try {
      this.checkForPanel();
    } catch (e) {
      console.error(e);
    }
  }
  whenActive(callback) {
    this.whenActiveHandler = callback;
  }
  whenInactive(callback) {
    this.whenInactiveHandler = callback;
  }
  checkForPanel() {
    if (!this.layersContainer) {
      throw `No layers container declared at constructor`;
    }
    if (
      this.item.dataset.panelTarget &&
      this.item.dataset.panelTarget.length > 0
    ) {
      let target = this.item.dataset.panelTarget;
      let panelEl = this.layersContainer.querySelector(
        ` [data-menu-panel="${target}"]`
      );
      if (panelEl) {
        this.panel = new LayerMenuPanel(panelEl);
        this.startListener();
      }
    }
  }
  isDesktop() {
    return !!window.matchMedia('(min-width:992px)').matches;
  }
  startListener() {
    // check if is desktop
    if (this.isDesktop()) {
      const ctx = this;
      let timer;
      const delayTimer = 400;
      this.item.addEventListener('mouseenter', e => {
        if (this.isDesktop()) {
          timer = setTimeout(function(){ ctx.showPanel(); }, delayTimer);
        }
      });
      this.item.addEventListener('mouseleave', e => {
        if (!this.panel.checkChild(e.relatedTarget) && this.isDesktop()) {
          clearTimeout(timer);
          this.hidePanel();
        }
      });
    } else {
      // mobile
      let detectTap;
      this.item.addEventListener('touchstart', e => {
        detectTap = true; // Detects all touch events
      });
      this.item.addEventListener('touchmove', e => {
        detectTap = false; // Excludes the scroll events from touch events
      });
      this.item.addEventListener('touchend', e => {
        e.preventDefault();
        if (event.type == "click") detectTap = true; // Detects click events
        if (detectTap){
          // Here you can write the function or codes you want to execute on tap
          this.showPanel();
        }
      });
      if (!('ontouchstart' in window)) {
        this.item.addEventListener('click', e => {
          e.preventDefault();
          this.showPanel();
        });
      }
    }
  }
  on(event, callback) {
    if (!this.panel) {
      return;
    }
    this.item.addEventListener(event, callback);
  }
  setActive(bool = true) {
    if (typeof bool !== 'boolean') {
      return;
    }
    this.item.classList.toggle(this.CLASSNAMES.active, bool);
  }
  showPanel() {
    if (!this.panel || this.panel.isActive) {
      return;
    }
    this.setActive();
    this.panel.showLayer();
    this.header.classList.add(this.CLASSNAMES.divider);
    //    this.whenActiveHandler();
    this.togglePanelsContainer(this.panel.isActive);
    this.panel.onLeave(e => {
      if (e.relatedTarget === this.item) {
        return;
      }
      this.hidePanel();
    });
    this.panel.whenBack(() => {
      this.hidePanel();
    });
  }
  hidePanel() {
    if (!this.panel) {
      return;
    }
    this.setActive(false);
    this.panel.hideLayer();
    if (!this.panel.isActive) {
      this.togglePanelsContainer(this.panel.isActive);
    }
    //    this.whenInactiveHandler();
  }
  togglePanelsContainer(bool = true) {
    if (typeof bool !== 'boolean') {
      return;
    }
    this.layersContainer.classList.toggle(this.CLASSNAMES.activeLayersContainer, bool);
  }
}
